/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigurationLayer } from './ConfigurationLayer';
import {
    ConfigurationLayerFromJSON,
    ConfigurationLayerFromJSONTyped,
    ConfigurationLayerToJSON,
    ConfigurationLayerToJSONTyped,
} from './ConfigurationLayer';

/**
 * 
 * @export
 * @interface ConfigurationView
 */
export interface ConfigurationView {
    /**
     * 
     */
    config_key: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * Send back as expected_version when changing this scope
     */
    scope_version: number;
    /**
     * The requested scope's own override, or null
     */
    scope_value: any | null;
    /**
     * The value after inheritance, or null
     */
    effective_value: any | null;
    /**
     * Layer each leaf came from, keyed by JSON pointer
     */
    sources: { [key: string]: ConfigurationLayer; };
}

/**
 * Check if a given object implements the ConfigurationView interface.
 */
export function instanceOfConfigurationView(value: object): value is ConfigurationView {
    if (!('config_key' in value) || value['config_key'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('scope_version' in value) || value['scope_version'] === undefined) return false;
    if (!('scope_value' in value) || value['scope_value'] === undefined) return false;
    if (!('effective_value' in value) || value['effective_value'] === undefined) return false;
    if (!('sources' in value) || value['sources'] === undefined) return false;
    return true;
}

export function ConfigurationViewFromJSON(json: any): ConfigurationView {
    return ConfigurationViewFromJSONTyped(json, false);
}

export function ConfigurationViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationView {
    if (json == null) {
        return json;
    }
    return {
        
        'config_key': json['config_key'],
        'facility_id': json['facility_id'],
        'scope_version': json['scope_version'],
        'scope_value': json['scope_value'],
        'effective_value': json['effective_value'],
        'sources': (mapValues(json['sources'], ConfigurationLayerFromJSON)),
    };
}

export function ConfigurationViewToJSON(json: any): ConfigurationView {
    return ConfigurationViewToJSONTyped(json, false);
}

export function ConfigurationViewToJSONTyped(value?: ConfigurationView | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'config_key': value['config_key'],
        'facility_id': value['facility_id'],
        'scope_version': value['scope_version'],
        'scope_value': value['scope_value'],
        'effective_value': value['effective_value'],
        'sources': (mapValues(value['sources'], ConfigurationLayerToJSON)),
    };
}

